// extracted by mini-css-extract-plugin
export var askAiIcon = "_mi-j";
export var category = "_mi-9";
export var categoryHeader = "_mi-e";
export var container = "_mi-0";
export var group = "_mi-a";
export var groupItems = "_mi-f";
export var groupSeparator = "_mi-k";
export var loading = "_mi-1";
export var noResults = "_mi-3";
export var placeholder = "_mi-2";
export var resultContent = "_mi-5";
export var resultIcon = "_mi-c";
export var resultItem = "_mi-g";
export var resultMeta = "_mi-8";
export var resultSubtitle = "_mi-7";
export var resultSuffix = "_mi-i";
export var resultTitle = "_mi-6";
export var resultsList = "_mi-4";
export var searchGroup = "_mi-d";
export var selected = "_mi-h";
export var subgroup = "_mi-b";